import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ModalLoading } from "../../../../../../common/components/modal_loading";

type props = {
    open: boolean,
    saving: boolean,
    onClose: () => void,
    onSubmit: () => void,
}

export const CopiaDiarioModal = ({
    open,
    saving,
    onClose,
    onSubmit,
}: props) => {

    const handleSubmit = useCallback((e?: React.FormEvent) => {
        e?.preventDefault();
        if (!saving) {
            onSubmit();
        }
    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "55rem",
                    },
                },
            }}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle>
                    Copiar Diario Obras
                </DialogTitle>

                <DialogContent>
                    <ModalLoading loading={saving} >
                        <div className="py-4">
                            <span className="text-lg">Deseja realmente fazer uma cópia deste diário?</span>
                        </div>
                    </ModalLoading>
                </DialogContent>

                <DialogActions>
                    <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">
                        <div className="flex flex-row gap-2">
                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={handleClose}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-[120px]">
                                <PrimaryButton
                                    type="submit"
                                    disabled={saving}
                                    buttonColor="primary-green"
                                >
                                    {saving ? "Salvando..." : "Salvar"}
                                </PrimaryButton>
                            </div>
                        </div>
                    </div>
                </DialogActions>
            </form>
        </Dialog>
    );
}